
<template>
  <div>
    <canvas :id="id">
      Your browser does not support the canvas element.
    </canvas>
  </div>
</template>

<script>
export default {
  props: {
    beginAtZero:{default:false},
    type:{
      default:'bar'
    },
    stacked:{
      defaul:false
    },
    hoverPointer: {
      default: false,
    },
    onClick: {
      default: () => () =>{ },
    },
    id: {
      require: true,
    },
    legendDisplay: {
      default: true,
    },
    datasets:{
      default: () => [
        {
          label: 'Pendiente',
          data: [
            {x:1, y: 100},
            {x:2, y: 150},
            {x:3, y: 97},
            {x:4, y: 50},
          ],
          backgroundColor: '#aaaaaa',
          borderColor: '#aaaaaa',
        },
        {
          label: 'Completado',
          data: [
            {x:1, y: 47},
            {x:2, y: 50},
            {x:3, y: 30},
            {x:4, y: 0},
          ],
          backgroundColor: '#454444',
          borderColor: '#454444',
        },
        {
          label: 'Iniciado',
          data: [
            {x:1, y: 30},
            {x:2, y: 50},
            {x:3, y: 25},
            {x:4, y: 25},
          ],
          backgroundColor: '#d99148',
          borderColor: '#d99148',
        },
      ]
    },
    labels:{
      default: () => ['Concentradora', 'NPI & CHO', 'Mina', 'Cátodos']
    },
    aspectRatio:{default:2}
  },
  data() {
    return {
      StackedBar:'',
    };
  },
  watch: {
    dark_t(val) { this.load() },
    datasets(val) { this.load() },
    mobil(val) {
      /* this.StackedBar.aspectRatio = ['sm','xs', 'md'].includes(val) ? 1: 2; */
    }
  },
  mounted(){ this.load() },
  methods: {
    load(){
      const hover = this.hoverPointer
        ? {
          onHover: function(e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = 'pointer';
            else e.target.style.cursor = 'default';
          }
        }
        : {};
      const {onClick,stacked,type} = this;
      var Chart = require('chart.js');
      var ctx = document.getElementById(this.id).getContext('2d');
      if (this.StackedBar.destroy) this.StackedBar.destroy();
      this.StackedBar = new Chart(ctx, {
        type,
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options:{
          onClick,
          hover,
          legend: {
            labels:{
              fontColor:this.dark_t?'white':'black'
            },
            display: this.legendDisplay
          },
          scales: {
            xAxes: [{
              display: true,
              gridLines: {
                color:this.dark_t?'white':'lightgrey',
              },
              ticks: {
                /* beginAtZero:true, */
                fontColor: this.dark_t?'white':'black',
              },
              stacked
            }],
            yAxes: [{
              display: true,
              gridLines: {
                color:this.dark_t?'white':'lightgrey',
              },
              ticks: {
                beginAtZero:this.beginAtZero,
                fontColor: this.dark_t?'white':'black',
              },
              stacked
            }],
          },
        }
      });
      this.StackedBar.aspectRatio = this.aspectRatio;
    }
  }, // methods
};
</script>
